export const FIELD_ID = {
  invoice: {
    number: 100023,
    amount: 100025,
    detail: 100070,
    outsideFirm: 100150,
    partialInvoice: 103555,
  },
  invoiceDetail: {
    fees: 100068,
    costs: 100069,
  },
}
